export const surveyHeadersData = [
  { text: 'Email', value: 'email', sortable: true, class: '' },
  { text: 'Year Born', value: 'year_born', sortable: true, class: '' },
  { text: 'Year Diagnosed', value: 'year_diagnosed', sortable: true, class: '' },
  { text: 'Gender', value: 'gender', sortable: true, class: '' },
  { text: 'Country', value: 'country', sortable: true, class: '' },
  { text: 'Total Time', value: 'total_time', sortable: true, class: '' },
  { text: 'Survey Answers', value: 'survey_count', sortable: true, class: '' },
];
